import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { AccessCodes } from '@pm2/api';
import { useCourseRevisionState, useActiveRevision } from '@pm2/course-revisions';
import { pm2SitemapStore, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { SizeTransition } from '@utils/react';
import { ChapterGroup } from './chapter-group.js';
import { NavItem } from './nav-item.js';
import { navItemTransitionCls, courseRevisionEditTransitionDurationMs, navListCls, transitionCls } from './nav-layer.style.js';
import { jsx } from 'react/jsx-runtime';

function NavLayer({
  parentDescriptor,
  onLinkClick,
  ref
}) {
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, parentDescriptor);
  const isEditingRevision = useCourseRevisionState(state => state.isEditing);
  const activeRevision = useActiveRevision(courseDescriptor?.id);
  if (!parentDescriptor.children?.length) {
    return null;
  }
  return /*#__PURE__*/jsx("ul", {
    ref: ref,
    className: cx(navListCls, transitionCls),
    children: /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: parentDescriptor.children.filter(childDescriptor => {
        if (childDescriptor.accessCode !== AccessCodes.ALLOWED ||
        // TeachersGuidePages will be pulled from traditional navigation
        // layer to a custom button, see ADO #113183
        childDescriptor.type === "TeachersGuidePage") {
          return false;
        }
        if (isEditingRevision) {
          return true;
        }
        if (childDescriptor.type === "ChapterGroup") {
          const hasEnabledChildren = childDescriptor.children?.some(it => it.accessCode === AccessCodes.ALLOWED && !activeRevision?.disabledContentIds[it.id]?.disabled);
          return hasEnabledChildren;
        }
        return !activeRevision?.disabledContentIds[childDescriptor.id]?.disabled;
      }).map(childDescriptor => {
        return /*#__PURE__*/jsx(SizeTransition, {
          axis: "vertical",
          timeout: courseRevisionEditTransitionDurationMs,
          classNames: navItemTransitionCls,
          delayMs: {
            enter: 100,
            exit: 100
          },
          children: ref => childDescriptor.type !== "ChapterGroup" ? /*#__PURE__*/jsx(NavItem, {
            ref: ref,
            pageDescriptor: childDescriptor,
            onLinkClick: onLinkClick
          }) : /*#__PURE__*/jsx(ChapterGroup, {
            ref: ref,
            parentDescriptor: childDescriptor,
            onLinkClick: onLinkClick
          })
        }, childDescriptor.id);
      })
    })
  });
}

export { NavLayer };
//# sourceMappingURL=nav-layer.js.map
